import React, { createContext } from 'react';
const LocaleContext = createContext(null);
export default LocaleContext;
